export default __webpack_public_path__ + "static/media/tramontana.4a4a0bb3.png";